import type { CSSProperties, ReactNode } from 'react';
import React from 'react';
import type { InputProps } from 'antd';
import type { InputStatus } from 'antd/es/_util/statusUtils';
import type { SizeType } from 'antd/es/config-provider/SizeContext';

import StyledInput, { InputLabel } from './styled.tsx';

export interface BaseInputProps extends InputProps {
    value?: string | number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    defaultValue?: string;
    disabled?: boolean;
    id?: string;
    maxLength?: number;
    prefixIcon?: ReactNode;
    suffixIcon?: ReactNode;
    placeholder?: string;
    type?: string;
    size?: SizeType;
    styles?: Record<string, CSSProperties>;
    status?: InputStatus;
    isSuccess?: boolean;
    hasError?: boolean;
    labelText?: string;
}

export const BaseInput: React.FC<BaseInputProps> = ({
    prefixIcon,
    suffixIcon,
    size = 'large',
    isSuccess = false,
    hasError = false,
    ...props
}) => (
    <>
        {!!props.labelText && <InputLabel>{props.labelText}</InputLabel>}
        <StyledInput
            className={isSuccess ? 'success' : hasError ? 'ant-input-status-error' : ''}
            {...props}
            prefix={prefixIcon}
            suffix={suffixIcon}
            size={size}
        />
    </>
);
